module.exports = __webpack_public_path__ + "static/img/Aaclogo6.14fe2dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aaclogo6.png
// module id = aQZb
// module chunks = 1